import React from "react";
import { FormattedMessage } from "react-intl";
import {
  LanguageSectionContainer,
  SectionRow,
} from "../../organisms/LogOutSection/styles";
import FlowioSelect from "../../atoms/inputs/FlowioSelect";
import { SelectedOptionValue } from "../../atoms/inputs/FlowioSelect/types";
import useLanguageSelect from "./useLanguageSelect";

export type ChangeLanguageProps = {
  locale: string;
  changeLocale: (newLocale: string) => void;
};

const ChangeLanguage = ({ locale, changeLocale }: ChangeLanguageProps) => {
  const selectOptions = useLanguageSelect();

  const onLocaleChange = (value: SelectedOptionValue) => {
    if (value === null) return;
    changeLocale(String(value));
  };

  return (
    <SectionRow>
      <LanguageSectionContainer data-cy="language-switch">
        <span>
          <FormattedMessage id="login.language" />
        </span>
        <FlowioSelect
          options={selectOptions}
          onChange={onLocaleChange}
          value={locale}
        />
      </LanguageSectionContainer>
    </SectionRow>
  );
};

export default ChangeLanguage;
